import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 100);
    const t2 = setTimeout(() => setPhase(2), 600);
    const t3 = setTimeout(() => setPhase(3), 1600);
    const t4 = setTimeout(() => onComplete(), 2200);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); };
  }, [onComplete]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#0a0a0a]"
      style={{
        opacity: phase >= 3 ? 0 : 1,
        transition: 'opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
      }}
      data-testid="splash-screen"
    >
      {/* Ambient glow */}
      <div
        className="absolute w-[500px] h-[500px] rounded-full"
        style={{
          background: 'radial-gradient(circle, rgba(196,30,58,0.15) 0%, transparent 70%)',
          opacity: phase >= 1 ? 1 : 0,
          transform: phase >= 1 ? 'scale(1)' : 'scale(0.3)',
          transition: 'all 1s cubic-bezier(0.16, 1, 0.3, 1)',
        }}
      />

      <div className="relative flex flex-col items-center">
        {/* Logo */}
        <div
          style={{
            opacity: phase >= 1 ? 1 : 0,
            transform: phase >= 1
              ? (phase >= 2 ? 'scale(1) translateY(0)' : 'scale(1.1) translateY(4px)')
              : 'scale(0.7) translateY(20px)',
            filter: phase >= 1 ? 'none' : 'blur(8px)',
            transition: 'all 0.7s cubic-bezier(0.16, 1, 0.3, 1)',
          }}
        >
          <img
            src="/logo.png"
            alt="BestCars"
            width="192"
            height="80"
            decoding="async"
            className="h-16 sm:h-20"
          />
        </div>

        {/* Line accent */}
        <div
          className="mt-6 h-[1px] bg-gradient-to-r from-transparent via-[#C41E3A] to-transparent"
          style={{
            width: phase >= 2 ? '160px' : '0px',
            opacity: phase >= 2 ? 1 : 0,
            transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
          }}
        />

        {/* Tagline */}
        <p
          className="mt-4 text-white/40 text-xs tracking-[0.3em] uppercase font-light"
          style={{
            opacity: phase >= 2 ? 1 : 0,
            transform: phase >= 2 ? 'translateY(0)' : 'translateY(8px)',
            transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.15s',
          }}
        >
          Stand Premium
        </p>
      </div>
    </div>
  );
};

export default SplashScreen;
